import { createClient } from "@supabase/supabase-js";
// 4mRrL*4qKL$M&b2
const supabaseURL = "https://iclpxdimnchdxslycjkq.supabase.co";

const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImljbHB4ZGltbmNoZHhzbHljamtxIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODk2NzMwNjksImV4cCI6MjAwNTI0OTA2OX0.Fmc95CilgaAtiPHZb1qZmMWKyKRRrgtqC5FOsjv7pt8";
const supabase = createClient(supabaseURL, supabaseKey);

export default supabase;
